import React from "react";
import { useTheme, Theme } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import { PropsAdronIcon } from "../../../_app/types";

// Компонент TetherIcon
const Filters = ({ size }: PropsAdronIcon) => {
  const theme: Theme = useTheme();
  return (
    <SvgIcon
      viewBox={size ? `0 0 ${size} ${size}` : undefined}
      style={size ? { width: size, height: size } : undefined}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 5.25H8.25M10.5 12.75H3.75M10.5 12.75C10.5 13.9926 11.5074 15 12.75 15C13.9926 15 15 13.9926 15 12.75C15 11.5074 13.9926 10.5 12.75 10.5C11.5074 10.5 10.5 11.5074 10.5 12.75ZM7.5 5.25C7.5 6.49264 6.49264 7.5 5.25 7.5C4.00736 7.5 3 6.49264 3 5.25C3 4.00736 4.00736 3 5.25 3C6.49264 3 7.5 4.00736 7.5 5.25Z"
          stroke={theme.palette.text.primary}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default Filters;
